module.exports = __webpack_public_path__ + "img/more.08cfd439.png";